'use es6';

import * as Actions from 'FormsUI/actions/UserPreferences';
import * as RequestStates from 'FormsCommonComponents/lib/RequestState';
const intialState = {
  requestState: RequestStates.NOT_REQUESTED,
  userPreferences: {}
};
export const userPreferences = (state = intialState, action) => {
  switch (action.type) {
    case Actions.REQUEST_USER_PREFERENCES:
      return Object.assign({}, state, {
        requestState: RequestStates.REQUESTED
      });
    case Actions.RECEIVE_USER_PREFERENCES:
      return Object.assign({}, state, {
        requestState: RequestStates.SUCCEEDED,
        userPreferences: action.preferences
      });
    case Actions.FAIL_GETTING_USER_PREFERENCES:
      return Object.assign({}, state, {
        requestState: RequestStates.FAILED
      });
    default:
      return state;
  }
};